import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BreadcrumbsStepComponent } from './breadcrumbs-step/breadcrumbs-step.component';
import { BreadcrumbsComponent } from './breadcrumbs.component';

@NgModule({
	declarations: [
		BreadcrumbsComponent,
		BreadcrumbsStepComponent,
	],
	imports: [
		CommonModule,
	],
	exports: [
		BreadcrumbsComponent,
		BreadcrumbsStepComponent,
	],
})
export class BreadcrumbsModule { }
